let health = [
  {
    path: '/health_record',
    name: '健康档案',
    component: () => import('@/pages/healthRecord/index')
  },
  {
    path: '/new_health',
    name: '新建健康档案',
    component: () => import('@/pages/healthRecord/new_health')
  },
  {
    path: '/change_health',
    name: '编辑健康档案',
    component: () => import('@/pages/healthRecord/change_health')
  }
]

export default health
